import { CountryCode, FlagComponent, Icons } from '@commenda/kakashi';
import { ISecureInformationRequestHeaderProps } from './types';

export const SecureInformationRequestLayoutHeader = ({
  onClose,
  headerProps,
}: {
  onClose: () => void;
  headerProps: ISecureInformationRequestHeaderProps;
}) => {
  const serviceRequestProps = headerProps as {
    serviceRequest?: {
      id: string | null;
      name: string | null;
    } | null;
  };

  return (
    <header className="p-xl flex items-start gap-xl border-b">
      <div className="flex-1 flex flex-col gap-xs">
        <div className="flex items-center gap-md">
          <h3 className="txt-large-bold">Secure Information Request</h3>
          <div className="flex items-center gap-lg">
            <div className="size-1 rounded-full bg-fg-tertiary" />
            {headerProps.shouldShowEntity ? (
              <div className="flex gap-md items-center">
                <FlagComponent
                  country={headerProps.businessEntity?.country as CountryCode}
                  countryName={headerProps.businessEntity?.country}
                  _className="size-4"
                />
                <span className="txt-medium-regular text-text-tertiary">
                  {headerProps.businessEntity?.name}
                </span>
              </div>
            ) : (
              <span className="txt-medium-regular text-text-tertiary">
                {serviceRequestProps?.serviceRequest?.name}
              </span>
            )}
          </div>
        </div>
        <p className="txt-small-regular text-text-secondary">
          {headerProps.description}
        </p>
      </div>
      <div
        role="button"
        tabIndex={0}
        className="p-[3px] flex justify-center items-center group"
        onClick={onClose}
      >
        <Icons.XClose className="size-5 text-fg-quaternary group-hover:text-fg-primary transition-colors" />
      </div>
    </header>
  );
};
